import { PushpinOutlined, SearchOutlined } from "@/icons"
import { ItemList } from "./ItemList"

import type { KeyItemListProps } from "./KeyItemList.types"

export const KeyList = (props: KeyItemListProps) => {
  const { services } = props
  const { FilterService, StringService } = services

  const currentValue = StringService.getTextByCaretPos()
  const items = FilterService.filterFilters(
    currentValue,
    StringService.getIds()
  )
  const nonFrequentItems = FilterService.filterByFrequencyType(
    items,
    "nonFrequent"
  )
  const frequentItems = FilterService.filterByFrequencyType(items, "frequent")

  const showFrequentItems = !!frequentItems?.length
  const showNonFrequentItems = !!nonFrequentItems?.length || !showFrequentItems

  return (
    <>
      {showFrequentItems && (
        <ItemList
          title="frequentlyUsed"
          Icon={PushpinOutlined}
          items={frequentItems}
          {...props}
        />
      )}
      {showNonFrequentItems && (
        <ItemList
          title="keys"
          Icon={SearchOutlined}
          items={nonFrequentItems}
          {...props}
        />
      )}
    </>
  )
}
